import React from "react";
import { Route, Routes } from "react-router-dom";
import IndexCompanyRoaster from "./companyRoster/IndexCompanyRoaster";
import IndexTimeSlots from "./timeSlots/IndexTimeSlots";
import IndexHolidays from "./holiday/IndexHolidays";
import IndexRestDays from "./restday/IndexRestDays";
import CreateCompanyRoaster from "./companyRoster/components/CreateCompanyRoaster";
import DeleteCompanyRoaster from "./companyRoster/components/DeleteCompanyRoaster";
import { useSelector } from "react-redux";
import { guardElement } from "@comps/components";
const RosterModules = () => {

  const authUser = useSelector((state) => state.auth.authUser);
  return (
    <Routes>
      <Route path="" element={ guardElement(<IndexCompanyRoaster module="companyRoaster" filters="" modkey="roster" />, "roster") } />
      <Route path="my-roster" element={ guardElement(<IndexCompanyRoaster module='myRoaster' filters={ `employee_|${authUser.employment_id}` } modkey="myRoster" />, "myRoster") } />
      <Route path="subordinate-roster" element={ guardElement(<IndexCompanyRoaster module="subordinateRoaster" filters={ `subordinate_|${authUser.employment_id}` } modkey="subordinateRoster" />, "subordinateRoster") } />
      <Route path="roster" element={ guardElement(<IndexCompanyRoaster module="companyRoaster" filters="" modkey="roster" />, "roster") } />
      <Route path="timeslots" element={ guardElement(<IndexTimeSlots modkey="timeSlot" />, "timeSlot") } />
      <Route path="holidays" element={ guardElement(<IndexHolidays modkey="holiday" />, "holiday") } />
      <Route path="rest-days" element={ guardElement(<IndexRestDays modkey="restDays" />, "restDays") } />
      <Route path="create" element={ guardElement(<CreateCompanyRoaster modkey="roster" />, "roster", "create") } />
      <Route path="delete" element={ guardElement(<DeleteCompanyRoaster modkey="roster" />, "roster", "delete") } />
    </Routes>
  );
}

export default RosterModules;
